import { Award, Truck, Shield } from "lucide-react";
import { useLang } from "../context/LanguageContext";

const CHIP_ICONS = [Award, Shield, Truck];

export function HeroChips() {
  const { t } = useLang();
  return (
    <div className="mt-8 flex flex-wrap gap-2" data-testid="hero-chips">
      {t.heroChips.map((c, i) => {
        const Icon = CHIP_ICONS[i] || Award;
        return (
          <div
            key={i}
            data-testid={`hero-chip-${i}`}
            className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/15 border border-white/25 backdrop-blur-md rounded-full px-4 py-2 text-white text-[12px] font-medium transition-colors"
            style={{ animation: `chip-fade 0.6s ease-out both`, animationDelay: `${0.1 * i + 0.4}s` }}
          >
            <Icon className="w-3.5 h-3.5 text-red-300" />
            {c}
          </div>
        );
      })}
    </div>
  );
}
